import { Button } from '@/components/Button';
import { ChooseTemplateSwiper } from '@/components/ChooseTemplateSwiper';
import { Slide4Template } from '@/templates/Slide4Template';
import { useUserData } from '@/contexts/UserDataContext';
import { type OcdFactData } from '@/types/userData';
import { useState } from 'react';

interface OcdFactStepProps {
    onNext: () => void;
}

export const OcdFactStep = ({ onNext }: OcdFactStepProps) => {
    const { updateUserData } = useUserData();
    const [selectedSlide, setSelectedSlide] = useState<number>(0);
    
    const handleSlideChange = (currentSlide: number) => {
        setSelectedSlide(currentSlide);
    };

    const handleNext = () => {
        const selectedOcdFact: OcdFactData = {
            text1: slides[selectedSlide].text1,
            text2: slides[selectedSlide].text2,
            text3: slides[selectedSlide].text3,
        };
        
        updateUserData({ selectedOcdFact });
        onNext();
    };

    const slides = [
        { text1: "And I am not alone, around", text2: "240M", text3: "People will develop OCD at some point in their life" },
        { text1: "And I am not the only one, it takes", text2: "7-17 years", text3: "on average to get an OCD diagnosis" },
        { text1: "And I am one of many, Doctors miss about", text2: "50%", text3: "of OCD cases in primary care" },
        { text1: "And this isn't just me, around", text2: "90%", text3: "of people with OCD also struggle with another disorder" },
        { text1: "And I am far from alone, more than", text2: "Half", text3: "of people with OCD receive no treatment" },
    ];
    
    return (
        <>
            <div className='flex-1 flex flex-col justify-center items-center gap-4 w-full overflow-y-auto'>
                <ChooseTemplateSwiper templates={
                    slides.map((slide) => <Slide4Template text1={slide.text1} text2={slide.text2} text3={slide.text3} />)
                } onSlideChange={handleSlideChange} />
            </div>
            <div className="shrink-0 flex justify-center items-center w-full px-8">
                <Button label="This one" onClick={handleNext} />
            </div>
        </>
    );
};